import { Option } from "./Auswahl";

export function Radios({
  options,
  name,
  value,
  onChange,
}: {
  options: Option[];
  name: string;
  value: Option;
  onChange: (value: Option) => void;
}) {
  return (
    <div className="radio form-controls" role="radiogroup" aria-label={name}>
      {options.map((option) => {
        const { label, isDisabled } = option;
        return (
          <label key={option.value} className="radio form-control">
            <input
              type="radio"
              name={name}
              value={option.value ?? ""}
              checked={value === option}
              onChange={() => onChange(option)}
              disabled={isDisabled}
            />
            {label}
          </label>
        );
      })}
    </div>
  );
}
